import format from 'date-fns/format';
import isValid from 'date-fns/isValid';

import { DateRangeVariant, DateVariant, PickerProps } from '../types';

export const FORMAT_TIME_STR = 'HH:mm';
export const FORMAT_DATE_STR = 'yyyy-MM-dd';

const formatDate = (date: Date, includeTime?: boolean, dateFormat = 'd MMM yyyy') => {
  if (includeTime) {
    return format(date, `${dateFormat}, h:mm a`);
  }
  return format(date, dateFormat);
};

export const getDatePickerValue = ({
  dateFormat,
  endTime,
  includeEndDate,
  includeTime,
  startTime,
}: {
  dateFormat?: string;
  endTime?: null | string;
  includeEndDate?: boolean;
  includeTime?: boolean;
  startTime?: null | string;
}) => {
  const formattedStartTime = startTime
    ? formatDate(new Date(startTime), includeTime, dateFormat)
    : '';
  const formattedEndTime = endTime ? formatDate(new Date(endTime), includeTime, dateFormat) : '';

  if (!formattedStartTime && !formattedEndTime) {
    return undefined;
  }

  if (includeEndDate) {
    return `${formattedStartTime} → ${formattedEndTime}`;
  }

  return formattedStartTime;
};

export const isValidDate = (date: Date) => isValid(date);

export const getValueBasedOnVariant = (pickerProps: PickerProps) => {
  if ('selectedTime' in pickerProps) {
    const { variant } = pickerProps;

    if (variant === DateVariant.Date) {
      return getDatePickerValue({
        dateFormat: pickerProps.dateFormat,
        startTime: pickerProps.selectedTime?.toISOString(),
      });
    }

    if (variant === DateVariant.DateAndTime) {
      return getDatePickerValue({
        dateFormat: pickerProps.dateFormat,
        includeTime: true,
        startTime: pickerProps.selectedTime?.toISOString(),
      });
    }
  }

  if ('selectedRange' in pickerProps) {
    const { variant } = pickerProps;

    if (variant === DateRangeVariant.DateRange) {
      return getDatePickerValue({
        endTime: pickerProps.selectedRange?.endTime?.toISOString(),
        includeEndDate: true,
        includeTime: false,
        startTime: pickerProps.selectedRange?.startTime?.toISOString(),
      });
    }

    if (variant === DateRangeVariant.DateAndTimeRange) {
      return getDatePickerValue({
        endTime: pickerProps.selectedRange?.endTime?.toISOString(),
        includeEndDate: true,
        includeTime: true,
        startTime: pickerProps.selectedRange?.startTime?.toISOString(),
      });
    }
  }
};
